import { FormEventType } from '@pages/WindowsCreateOrEdit/types'

import { EVENT_CODE } from '@constants'

export const filterEventsByEventCode = (events: FormEventType[], eventCode: EVENT_CODE) => {
  return events.filter(event => event.eventCode === eventCode)
}
